import { attachSentryUser } from './sentry'; // MUST be first — side-effect init + helper
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { useAuthStore } from '@/stores/auth';
import { ReconnectOverlay } from '@/components/ui/ReconnectOverlay';
import '@fontsource/nunito-sans/400.css';
import '@fontsource/nunito-sans/600.css';
import '@fontsource/nunito-sans/700.css';
import '@fontsource/nunito-sans/800.css';
import '@fontsource/nunito-sans/900.css';
import './index.css';

attachSentryUser(useAuthStore.getState().user);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
    <ReconnectOverlay />
  </React.StrictMode>
);
